import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class AkilliSayacListeAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "AkilliSayacListe";
        super(baseUrl);
    }
    getAkilliSayacListe(firmaKodu?: number) {
        const queryParams = [];

        return this.get("", { params: { firmaKodu: firmaKodu } });
    }
}
export default new AkilliSayacListeAPI();
class AkilliSayacListeRequest {
    public firmaKodu?: number;

    constructor(firmaKodu?: number,) {
        this.firmaKodu = firmaKodu;
    }
}
export { AkilliSayacListeRequest };